import React from 'react';
import Button from '../../../components/Button';

interface QuickActionsProps {
  onFindLocation: () => void;
  onAnalyzeCompetition: () => void;
  onRunMarketReport: () => void;
  onMonitorSite: () => void;
  onGetAISuggestions: () => void;
}

const QuickActions: React.FC<QuickActionsProps> = ({
  onFindLocation,
  onAnalyzeCompetition,
  onRunMarketReport,
  onMonitorSite,
  onGetAISuggestions
}) => {
  return (
    <div style={{ 
      marginBottom: '2rem',
      backgroundColor: '#fff',
      borderRadius: '8px',
      padding: '1.25rem',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    }}>
      <h3 style={{ 
        fontSize: '1.4rem', 
        marginBottom: '1rem', 
        color: '#1e1e1e' 
      }}>
        Quick Actions
      </h3>
      
      <div style={{ 
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '0.75rem'
      }}>
        <Button 
          onClick={onFindLocation}
          style={{
            padding: '0.75rem 1rem',
            fontSize: '0.95rem',
            width: '100%',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          Find a Business Location
        </Button>
        
        <Button 
          onClick={onAnalyzeCompetition}
          style={{
            padding: '0.75rem 1rem',
            fontSize: '0.95rem',
            width: '100%',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          Analyze Competition
        </Button>
        
        <Button 
          onClick={onRunMarketReport}
          style={{
            padding: '0.75rem 1rem',
            fontSize: '0.95rem',
            width: '100%',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          Run Market Report
        </Button>
        
        <Button 
          onClick={onMonitorSite}
          style={{
            padding: '0.75rem 1rem',
            fontSize: '0.95rem',
            width: '100%',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          Monitor Site Activity
        </Button>
        
        <Button 
          onClick={onGetAISuggestions} 
          style={{ 
            backgroundColor: '#7FE7D9', 
            color: '#1e1e1e',
            padding: '0.75rem 1rem',
            fontSize: '0.95rem',
            width: '100%',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          Get AI Suggestions
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;
